var i18nForMixin;

i18nForMixin = require('lib/react_utils').i18nForMixin;

module.exports = function(namespace) {
  return i18nForMixin(namespace);
};
